const CartCoupon = () => {
    return null;
};

export default CartCoupon;